"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = addScriptToDOM;
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var DATA_ID = 'data-id';

// eslint-disable-next-line default-param-last
function addScriptToDOM(url) {
  var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var id = arguments.length > 2 ? arguments[2] : undefined;
  return new _promise["default"](function (resolve, reject) {
    // check if a script already exists with this id, if provided
    var isScriptLoaded;
    if (id) {
      var _context;
      var existingScript = document.querySelector((0, _concat["default"])(_context = "script[".concat(DATA_ID, "=\"")).call(_context, id, "\"]"));
      isScriptLoaded = !!existingScript;
    }
    if (!isScriptLoaded) {
      var _context2;
      var script = document.createElement('script');
      script.src = url;

      // Set all given attributes
      (0, _forEach["default"])(_context2 = (0, _keys["default"])(attributes)).call(_context2, function (key) {
        script.setAttribute(key, attributes[key]);
      });
      if (id) {
        script.setAttribute(DATA_ID, id);
      }

      // Set promise callbacks
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    }
  });
}